<template>
    <vue-bottom-sheet-vue2 ref="bottomSheet"
        :max-height="90"
        :init-sheet-height="300"
        :close-height-percent="80"
    >
        <slot />
    </vue-bottom-sheet-vue2>
</template>

<script>
import VueBottomSheetVue2 from "@webzlodimir/vue-bottom-sheet-vue2";

export default {
    components: {
        VueBottomSheetVue2,
    },
    methods: {
        open() {
            this.$refs.bottomSheet.open();
        },
        close() {
            this.$refs.bottomSheet.close();
        },
    },
};
</script>
